import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { PopOutWrapper } from "src/library/components/ActionsPopOut/index";
import { Icon } from "src/library/components/Icon";
import { Text } from "src/library/components/Text";
import { Icons } from "src/library/components/Icon/types";
import { IOrderLineError } from "src/core/errors/api/errors.api";

interface IOrderLineErrorProps {
  errors?: IOrderLineError[];
}

const OrderLineError: React.ReactFCWithChildren<IOrderLineErrorProps> = ({ errors }) => {
  const [ isOpen, setIsOpen ] = React.useState(false);
  const errorPopoutRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    document.addEventListener("click", event => {
      if (errorPopoutRef.current && !errorPopoutRef.current.contains(event.target as Node)) {
        handleClose();
      }
    });

    return () => {
      document.removeEventListener("click", () => handleClose());
    };
  }, [ errorPopoutRef ]);

  const handleClose = () => {
    setIsOpen(false);
  };

  if (errors && errors.length > 0) {
    return (
      <div ref={errorPopoutRef}>
        <Grid.Bounds
          shiftRight
          style={{ position: "relative" }}
          valign="center"
        >
          <Icon
            icon={Icons.ERRORCIRCLE}
            $fillColor="error"
            onClick={() => setIsOpen(true)}
          />

          {isOpen && (
            <Wrapper className="pull-right">
              <Grid.Bounds
                className="error-header"
                valign="top"
              >
                <Text
                  className="error-title"
                  fontSize="h3"
                  as="h3"
                >
                  Error
                </Text>

                <Grid.Box shiftRight>
                  <Icon
                    className="close-icon"
                    icon={Icons.CLOSE}
                    $fillColor="primaryDark"
                    $hoverColor="primaryLight"
                    onClick={() => handleClose()}
                  />
                </Grid.Box>
              </Grid.Bounds>

              {errors.map(erorrLine => (
                <Grid.Box
                  className="error-line"
                  key={erorrLine.entityId}
                >
                  <Text>
                    {erorrLine.note}
                  </Text>
                </Grid.Box>
              ))}
            </Wrapper>
          )}
        </Grid.Bounds>
      </div>
    );
  }

  return null;
};

const Wrapper = styled(PopOutWrapper)`
  ${({ theme }) => css`
    background: ${theme.colors.errorLight};
    border: ${theme.colors.error} 1px solid;

    &:before {
      border-bottom: 10px solid ${theme.colors.error};
      z-index: 10;
    }

    .error-title {
      margin: ${theme.spacing.margins.md};
      margin-bottom: 0;
    }

    .error-line {
      margin: ${theme.spacing.margins.md};
      margin-top: 0;
    }
  `}
`;

export default OrderLineError;
